import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TablePagination } from "@mui/material";
import moment from "moment";
import {
    FaFileAlt,
    FaUserCircle,
    FaHashtag
} from "react-icons/fa";
import Loader from "../../Components/Loader/Loader";
import { DayReportFindforcheqall } from "../../Redux/Slice/Day";

export const AllTaskReport = ({
    selectedMember,
    startDate,
    endDate,
    filterDateType = "GeneratedDate",
    startDateInvalid,
    endDateInvalid,
    refreshActivity
}) => {
    const dispatch = useDispatch();
    const { DayReportFindforcheqallData, DayReportFindforcheqallLoading } = useSelector(
        (state) => state.Day || {}
    );

    const [data1TableData, setData1TableData] = useState([]);

    // Pagination state
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        setPage(0);
    }, [startDate, endDate, selectedMember]);

    // Fetch data on dependencies change
    useEffect(() => {
        dispatch(
            DayReportFindforcheqall({
                page: page + 1,
                limit: rowsPerPage,
                memberId: selectedMember?.Name_id,
                startDate: !startDateInvalid && startDate ? startDate : undefined,
                endDate: !endDateInvalid && endDate ? endDate : undefined,
                filterDateType
            })
        );
    }, [
        dispatch,
        page,
        rowsPerPage,
        selectedMember,
        startDate,
        endDate,
        filterDateType,
        startDateInvalid,
        endDateInvalid,
        refreshActivity
    ]);

    // Update local state when data is fetched safely
    useEffect(() => {
        if (Array.isArray(DayReportFindforcheqallData?.data)) {
            setData1TableData(DayReportFindforcheqallData.data);
        }
    }, [DayReportFindforcheqallData]);

    const handleData1RowClick = (item) => {
        console.log("Row clicked:", item);
    };

    // Only show full loader on initial fetch when no data is loaded yet
    if (DayReportFindforcheqallLoading && (!data1TableData || data1TableData.length === 0)) {
        return <Loader />;
    }

    const filteredData = Array.isArray(data1TableData) ? data1TableData : [];
    const totalAllCount = DayReportFindforcheqallData?.totalData || 0;
    const maxPage = Math.max(0, Math.ceil(totalAllCount / rowsPerPage) - 1);
    const safePage = page > maxPage ? 0 : page;

    return (
        <div className="bg-white shadow-xl rounded-xl rounded-tl-none overflow-hidden border border-gray-100 relative z-0">
            <div className="px-6 py-4 bg-gray-50 border-b border-gray-200 flex justify-between items-center flex-wrap gap-4">
                <div className="flex items-center gap-3">
                    <div className="bg-[#133A69] p-2 rounded-lg">
                        <FaFileAlt className="text-white" size={18} />
                    </div>
                    <div>
                        <h4 className="text-lg font-semibold text-gray-800">
                            Activity Details
                        </h4>
                        <p className="text-xs text-gray-500 mt-0.5">
                            Detailed activity log
                        </p>
                    </div>
                </div>

                <div className="flex items-center gap-4">
                    {DayReportFindforcheqallLoading && (
                        <span className="text-xs text-indigo-600 font-semibold animate-pulse">
                            Updating...
                        </span>
                    )}
                    <span className="bg-[#133A69] text-white px-4 py-1.5 rounded-full text-xs font-bold shadow-sm whitespace-nowrap">
                        Total: {totalAllCount}
                    </span>
                </div>
            </div>

            <div className="overflow-auto max-h-[850px] relative scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-thin">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-[#133A69] text-white sticky top-0 z-10 shadow-sm">
                        <tr>
                            <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider w-16 bg-[#133A69]">
                                NO
                            </th>
                            <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider bg-[#133A69]">
                                MEMBER
                            </th>
                            <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider bg-[#133A69]">
                                GENERATED DATE
                            </th>
                            <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider bg-[#133A69]">
                                COMPANY
                            </th>
                            <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider bg-[#133A69]">
                                CALL NO
                            </th>
                            <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider min-w-[400px] bg-[#133A69]">
                                DESCRIPTION
                            </th>
                            <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider min-w-[200px] bg-[#133A69]">
                                REMARK
                            </th>
                            <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider bg-[#133A69]">
                                INTIMATION
                            </th>
                            <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider w-20 bg-[#133A69]">
                                TASK DEMO
                            </th>
                            <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider bg-[#133A69]">
                                CHECK DATE
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 bg-white">
                        {filteredData.length === 0 ? (
                            <tr>
                                <td colSpan={10} className="text-center border-none h-[400px]">
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <div className="w-16 h-16 bg-[#F0F7FF] rounded-full flex items-center justify-center mb-4 shadow-sm border border-[#E8F2FF]">
                                            <svg className="w-8 h-8 text-[#133a69]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                                            </svg>
                                        </div>
                                        <h3 className="text-base font-bold text-[#133a69] mb-1 tracking-wide">No Data Found</h3>
                                        <p className="text-gray-500 text-sm text-center max-w-[280px] leading-relaxed">
                                            We couldn't find any records matching your filters.
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            filteredData.map((item, index) => {
                                const companyNameVal =
                                    typeof item?.WorkId?.CompanyName === "object"
                                        ? item?.WorkId?.CompanyName?.WhaClientName || item?.WorkId?.CompanyName?.CompanyName
                                        : item?.WorkId?.CompanyName || "-";

                                const callNoStr =
                                    item?.WorkId?.CallNo != null ? String(item.WorkId.CallNo).replace("#", "") : "N/A";

                                return (
                                    <tr
                                        key={item?._id || index}
                                        className="hover:bg-blue-50/50 transition-colors cursor-pointer group"
                                        onClick={() => handleData1RowClick(item)}
                                    >
                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-bold text-gray-500">
                                            {safePage * rowsPerPage + index + 1}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="flex items-center">
                                                <div className="flex-shrink-0 h-9 w-9 mr-3">
                                                    {item?.Memberid?.ProfilePhoto ? (
                                                        <img
                                                            src={item.Memberid.ProfilePhoto}
                                                            alt={item.Memberid?.Name}
                                                            className="h-9 w-9 rounded-full object-cover ring-2 ring-white shadow-sm"
                                                        />
                                                    ) : (
                                                        <div className="h-9 w-9 rounded-full bg-indigo-100 flex items-center justify-center ring-2 ring-white shadow-sm">
                                                            <FaUserCircle className="h-6 w-6 text-indigo-500" />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="text-sm font-semibold text-gray-800 group-hover:text-indigo-700 transition-colors">
                                                    {item?.Memberid?.Name || "N/A"}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                            <div className="text-sm font-medium text-gray-600 bg-gray-50 px-2 py-1 rounded inline-block">
                                                {item?.GeneratedDate && moment(item.GeneratedDate).isValid()
                                                    ? moment(item.GeneratedDate).utc().format("MMM DD, YYYY")
                                                    : "-"}
                                            </div>
                                            <div className="text-xs text-gray-400 mt-1">
                                                {item?.GeneratedDate && moment(item.GeneratedDate).isValid()
                                                    ? moment(item.GeneratedDate).utc().format("hh:mm A")
                                                    : ""}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="text-sm font-medium text-gray-800">
                                                {companyNameVal}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                            <span
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (item?.WorkId?._id) {
                                                        window.open(`/InhouseRnd/CustomerrequustDetail/${item.WorkId._id}`, "_blank");
                                                    }
                                                }}
                                                className="inline-flex items-center text-sm px-3 py-1 bg-[#112A47]/10 rounded-full font-medium text-[#112A47] cursor-pointer hover:bg-[#112A47]/20 transition-colors"
                                            >
                                                <FaHashtag className="mr-1 text-xs" />
                                                {callNoStr}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div
                                                className="text-sm text-gray-600 leading-relaxed text-left w-full break-words whitespace-pre-wrap bg-gray-50 p-3 rounded-lg border border-gray-200 shadow-sm min-h-[50px]"
                                                title={item?.Description}
                                            >
                                                {item?.Description || "-"}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div
                                                className="text-sm text-gray-600 leading-relaxed text-left w-full break-words whitespace-pre-wrap bg-gray-50 p-3 rounded-lg border border-gray-200 shadow-sm min-h-[50px]"
                                                title={item?.Remark}
                                            >
                                                {item?.Remark || "-"}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                            <span
                                                className={`px-3 py-1 rounded-full text-xs font-bold border shadow-sm ${
                                                    item?.Tec
                                                        ? "bg-green-50 text-green-700 border-green-200"
                                                        : "bg-yellow-50 text-yellow-700 border-yellow-200"
                                                }`}
                                            >
                                                {item?.Tec ? "Verified" : "Pending"}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                            <span
                                                className={`px-3 py-1 rounded-full text-xs font-bold border shadow-sm ${
                                                    item?.Phys
                                                        ? "bg-green-50 text-green-700 border-green-200"
                                                        : "bg-yellow-50 text-yellow-700 border-yellow-200"
                                                }`}
                                            >
                                                {item?.Phys ? "Verified" : "Pending"}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                            <div className="text-sm font-medium text-gray-600 bg-gray-50 px-2 py-1 rounded inline-block">
                                                {item?.CheckdDate && moment(item.CheckdDate).isValid()
                                                    ? moment(item.CheckdDate).utc().format("MMM DD, YYYY")
                                                    : "-"}
                                            </div>
                                            <div className="text-xs text-gray-400 mt-1">
                                                {item?.CheckdDate && moment(item.CheckdDate).isValid()
                                                    ? moment(item.CheckdDate).utc().format("hh:mm A")
                                                    : ""}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <TablePagination
                component="div"
                count={totalAllCount}
                page={safePage}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                className="bg-gray-50 border-t border-gray-200"
            />
        </div>
    );
};
